"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.IS_DISABLED_OPTIONS = exports.INITIAL_VALUES = exports.ICON = exports.FIELDS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TRANSLATION = {
  isOfw: 'Are you an Overseas Filipino Worker (OFW)?',
  yes: 'Yes',
  no: 'No',
  ofwId: 'OFW ID',
  ofwNoteHeader: 'OFW Disclaimer',
  ofwNote: "Pursuant to R.A. 8042 as amended by R.A. 10022, \n  OFWs are exempted from paying airpot tax or International Passenger Service Charge (IPSC). \n  OFWs must input their OFW ID number to remove IPSC from their booking. \n  Valid documents must be presented at the airport for verification. \n  Failure to do so may result in penalties or denial of boarding.",
  requiredError: 'This field is required.'
};
exports.TRANSLATION = TRANSLATION;
var IS_DISABLED_OPTIONS = [{
  label: TRANSLATION.yes,
  value: 'true'
}, {
  label: TRANSLATION.no,
  value: 'false'
}];
exports.IS_DISABLED_OPTIONS = IS_DISABLED_OPTIONS;
var FIELDS = {
  isOfw: {
    label: TRANSLATION.isOfw,
    name: 'isOfw'
  },
  ofwId: {
    label: TRANSLATION.ofwId,
    name: 'ofwId'
  }
};
exports.FIELDS = FIELDS;

var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));

exports.INITIAL_VALUES = INITIAL_VALUES;
var ICON = {
  COLOR: 'greyDark',
  FONTSIZE: 'titleSmall',
  TYPE: 'InfoIcon'
};
exports.ICON = ICON;
var TEXT = {
  DISPLAY: 'inlineFlex',
  TYPE: 'sub',
  COLOR: 'secondary'
};
exports.TEXT = TEXT;